import React, { useEffect, useState } from 'react';
import { ChevronDown, ChevronUp } from 'react-feather';
import { Typography } from '@/UIlibrary/Typography/Typography';
import { Link } from 'react-router-dom';
import { theme } from './theme';
import './SidebarSection.css';

interface LogoutSectionProps {
	profilePicture: React.ReactNode;
	title: string;
	logoutTitle: string;
	collapsed: boolean;
	handleLogOut: () => void;
	currentPath: string;
	supportTitle: string;
}

const LogoutSection: React.FC<LogoutSectionProps> = ({
	profilePicture,
	title,
	logoutTitle,
	collapsed,
	handleLogOut,
	supportTitle
}) => {
	const [toggleSection, setToggleSection] = useState(false);

	useEffect(() => {
		if (collapsed) setToggleSection(false);
	}, [collapsed]);

	const setToggleButtonIcon = () => {
		return toggleSection ? <ChevronDown size={24} /> : <ChevronUp size={24} />;
	};

	const handleSectionClick = () => {
		if (!collapsed) setToggleSection(!toggleSection);
	};

	const componentStyles = () => {
		const baseStyles = theme.sidebarSection;
		const openStyles = toggleSection ? theme.sectionOpen : {};

		return {
			...baseStyles,
			...openStyles
		};
	};

	return (
		<ul>
			<>
				<section
					style={{ ...componentStyles(), height: '56px' }}
					className={`logout-section ${collapsed ? 'collapsed-sidebar-section' : ''}`}
					onClick={handleSectionClick}
				>
					{profilePicture}
					{!collapsed && (
						<>
							<span className="section-text">{title}</span>
							{setToggleButtonIcon()}
						</>
					)}
					{toggleSection && (
						<div style={{ ...theme.logoutSectionContent }} className="logout-section-content">
							<li
								onClick={() => handleLogOut()}
								style={{ borderBottom: '1px solid lightgray' }}
								className="logout-section-item"
							>
								{
									<Typography size="sm" weight="semibold">
										{logoutTitle}
									</Typography>
								}
							</li>
							<Link to={'/support'}>
								<li className="logout-section-item">
									{
										<Typography size="sm" weight="semibold">
											{supportTitle}
										</Typography>
									}
								</li>
							</Link>
						</div>
					)}
				</section>
			</>
		</ul>
	);
};

export default LogoutSection;
